import React from 'react';
import {Field} from 'formik';
import {
    TextField,
    Typography
} from "@mui/material";
import Grid from "@mui/material/Grid2"
import TypologieLavageBadge from "../../layout/TypologieLavageBadge.js";

function TypologieLavageDataField({values, errors, handleChange, handleBlur}) {
    return (
        <Grid container spacing={1} className={"sectionContainer"}>
            <Grid size={12}>
                <Typography variant={"h5"} className={"sectionHeader"}>Informations</Typography>
            </Grid>

            {/* LIBELLÉ */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Libellé <span className="asterix">*</span>
                </Grid>
                <Grid size={9}>
                    <Field type="text" value={values.libelle}>
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.libelle && form.touched.libelle)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.libelle}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="libelle"
                                label="Libellé"
                                helperText={
                                    form.errors.libelle &&
                                    form.touched.libelle &&
                                    String(form.errors.libelle)
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>


            {/* COULEUR */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Couleur <span className="asterix">*</span>
                </Grid>
                <Grid size={2}>
                    <Field type="color" value={values.couleur}>
                        {({field, form}) => (
                            <TextField
                                error={Boolean(form.errors.couleur && form.touched.couleur)}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.couleur}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                name="couleur"
                                label="Couleur"
                                type="color"
                                slotProps={{
                                    input: {
                                        style: {height: "3rem", padding: 0, width: "5rem"}
                                    },
                                    inputLabel: {shrink: true}
                                }}
                                helperText={
                                    form.errors.couleur &&
                                    form.touched.couleur &&
                                    String(form.errors.couleur)
                                }
                            />
                        )}
                    </Field>
                </Grid>
                <Grid size={4}>
                    <TypologieLavageBadge typologie={{libelle: values.libelle ?? "Aperçu", couleur: values.couleur}}/>
                </Grid>
            </Grid>

            {/* CONSO EAU — REP-03 R7 : matrice d'estimation du bilan par actes. Vide = pas d'estimation
                (le KPI eau du bilan est alors absent pour les périodes qui contiennent cette typologie). */}
            <Grid item container size={12} alignItems={"center"}>
                <Grid size={3}>
                    Conso. eau (estimation)
                </Grid>
                <Grid size={3}>
                    <Field name="consoEauLitresParBac">
                        {({field, form}) => (
                            <TextField
                                {...field}
                                error={Boolean(form.errors.consoEauLitresParBac && form.touched.consoEauLitresParBac)}
                                variant="outlined"
                                margin="normal"
                                size="small"
                                fullWidth
                                type="number"
                                label="Litres par bac lavé"
                                slotProps={{
                                    htmlInput: {min: 0, step: 0.5},
                                    inputLabel: {shrink: true}
                                }}
                                helperText={
                                    (form.errors.consoEauLitresParBac && form.touched.consoEauLitresParBac && String(form.errors.consoEauLitresParBac))
                                    || "Sert au KPI « eau extrapolée » du bilan par actes. Vide = pas d'estimation."
                                }
                            />
                        )}
                    </Field>
                </Grid>
            </Grid>
        </Grid>
    );
}

export default TypologieLavageDataField;
